import {useState} from "react";
import {Card, Col, Collapse, Container, Row} from "react-bootstrap";
import {determinBorder, determinColor, getDisplayStatus} from "../service/jobutil";
import {CopyAddress} from "./CopyAddress";
import UpdateButtonMenu from "./UpdateJobButtonMenu";

function buildTaskTitle(job, sameDaySchedule) {
    const titleParts = [job.full_address, job.key_number, job.agent_name].filter(Boolean);
    const hasSameDayJob = Boolean(sameDaySchedule?.hasSameDayJob);
    const resolvedCheckOut = hasSameDayJob ? sameDaySchedule?.checkOut : job.check_out;
    const resolvedCheckIn = hasSameDayJob ? sameDaySchedule?.checkIn : job.check_in;

    if (resolvedCheckOut) {
        titleParts.push(`CheckOut:${resolvedCheckOut}`);
    }

    if (resolvedCheckIn) {
        titleParts.push(`CheckIn:${resolvedCheckIn}`);
    }

    return titleParts.join(", ");
}

function buildTaskTagStyle(color) {
    return {
        display: "inline-block",
        backgroundColor: "#fff",
        color,
        border: `1.5px solid ${color}`,
        borderRadius: "4px",
        padding: "2px 8px",
        fontSize: "0.85em",
        fontWeight: 600,
        marginLeft: "8px",
        marginRight: "4px",
        verticalAlign: "middle",
    };
}

export default function TaskCardList({
    job,
    fieldWorkerMap,
    isLoading,
    onEditJob,
    defaultOpen = false,
    sameDayAssignmentLabel = "",
    sameDaySchedule = null,
}) {
    const [open, setOpen] = useState(defaultOpen);
    const defaultTagColor = determinColor(job);
    const showSameDayB2BTag = Boolean(sameDaySchedule?.checkOut || sameDaySchedule?.checkIn);

    return (
        <div style={{marginBottom: "3px"}}>
            <Container fluid>
                <Row>
                    <Col>
                        <Card
                            style={{textAlign: "left", userSelect: "text"}}
                            draggable={!isLoading}
                            onDragStart={(event) => event.dataTransfer.setData("cos_job_id", job.cos_job_id)}
                            border={determinBorder(job)}
                        >
                            <Card.Body>
                                <div onClick={() => setOpen(!open)}>
                                    <div style={{display: "flex"}}>
                                        <span>
                                            <b>{buildTaskTitle(job, sameDaySchedule)}</b>
                                            {job.tags && job.tags.includes("B2B_NEW") ? (
                                                <span style={buildTaskTagStyle("red")}>
                                                    B2B_NEW
                                                </span>
                                            ) : showSameDayB2BTag ? (
                                                <span style={buildTaskTagStyle(defaultTagColor)}>
                                                    B2B
                                                </span>
                                            ) : null}
                                            <CopyAddress job={job} />
                                        </span>
                                        <span style={{marginLeft: "auto", color: determinColor(job)}}>
                                            <b>{getDisplayStatus(job)}</b>
                                        </span>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                        <span style={{flex: 1, color: "#0d6efd", display: "inline-flex", alignItems: "center", flexWrap: "wrap"}}>
                                            <b>Task ID:</b> {job.cos_job_id}
                                            {sameDayAssignmentLabel ? (
                                                <span style={buildTaskTagStyle("#0d6efd")}>
                                                    {sameDayAssignmentLabel}
                                                </span>
                                            ) : null}
                                        </span>
                                        <span style={{flex: 1, textAlign: "right"}}>Date: {job.date}</span>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                        <span style={{flex: 1, textAlign: "right"}}>
                                            <b>Worker: </b>
                                            {fieldWorkerMap[job.cos_job_worker] || ""}
                                        </span>
                                    </div>
                                </div>
                                <Collapse in={open}>
                                    <div>
                                        <div style={{marginTop: "20px"}}>
                                            <span>{job.description}</span>
                                        </div>
                                        <div style={{display: "flex", marginTop: "20px"}}>
                                            <span>
                                                {job.email}<br />
                                                {job.phone}
                                            </span>
                                            <span style={{marginLeft: "auto"}}>
                                                <UpdateButtonMenu row={job} onClick={onEditJob} />
                                                <br />
                                            </span>
                                        </div>
                                    </div>
                                </Collapse>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
